module.exports = __webpack_public_path__ + "static/media/Promo_Card_2.d744fdb7.png";